// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_458baa2","imageWrapper":"_0c9cac4","imageText":"_2d66c03","headingsSlider":"_70f03e3","twoSlides":"_2f12987","heading":"_6313248"};